import type { BurbankCapElectricityYear, BurbankCapPublishedBundle } from './types';
import bundleJson from './data/burbankCapPublished.generated.json';

let cached: BurbankCapPublishedBundle | null = null;

export function loadBurbankCapPublishedBundle(): BurbankCapPublishedBundle {
  if (!cached) {
    cached = bundleJson as BurbankCapPublishedBundle;
  }
  return cached;
}

export const BURBANK_CAP_COMPARISON_YEARS = [2010, 2019, 2022, 2024] as const;

export function capElectricityForYear(
  bundle: BurbankCapPublishedBundle,
  year: number
): BurbankCapElectricityYear | null {
  const row = bundle.capElectricity[String(year)];
  return row ?? null;
}

export function eiaReconciliationForYear(
  bundle: BurbankCapPublishedBundle,
  year: number
): { residential_kwh: number; nonresidential_kwh: number } | null {
  return bundle.eiaReconciliation[String(year)] ?? null;
}

export function pctDiff(capValue: number, baseline: number): number {
  if (baseline === 0) return 0;
  return (100 * (capValue - baseline)) / baseline;
}
